<template>
  <v-card class="pa-4">
    <h2>Usuarios</h2>
    <v-btn color="primary" @click="fetchUsers">Recargar</v-btn>
    <v-data-table :items="users" :headers="headers" class="mt-4" />
  </v-card>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import api from '@/plugins/axios'
defineOptions({
  name: 'UsersView'
})
interface User {
  id: number
  name: string
  email: string
}

const users = ref<User[]>([])

const headers = [
  { title: 'ID', value: 'id' },
  { title: 'Nombre', value: 'username' },
  { title: 'date', value: 'creado' }
]

const fetchUsers = async () => {
  const res = await api.get('/usuario')
  users.value = res.data
}

onMounted(fetchUsers)
</script>
